'use client';

import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import { WishlistCounter } from './WishlistCounter';
import type { MiniBannerCounterProps } from './types';

const BonusCounter = dynamic(
  async () => import('./BonusCounter').then((module) => module.BonusCounter),
  { ssr: false, loading: () => null }
);

const CashbackCounter = dynamic(
  async () =>
    import('./CashbackCounter').then((module) => module.CashbackCounter),
  { ssr: false, loading: () => null }
);

const StatusCounter = dynamic(
  async () => import('./StatusCounter').then((module) => module.StatusCounter),
  { ssr: false, loading: () => null }
);

const WheelCounter = dynamic(
  async () => import('./WheelCounter').then((module) => module.WheelCounter),
  { ssr: false, loading: () => null }
);

export const MiniBannerCounter = ({
  counterKey,
  renderCounter,
}: MiniBannerCounterProps) => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if ('requestIdleCallback' in window) {
      const id = window.requestIdleCallback(() => setIsReady(true), {
        timeout: 2000,
      });

      return () => {
        window.cancelIdleCallback(id);
      };
    }

    const id = window.setTimeout(() => setIsReady(true), 2000);
    return () => {
      window.clearTimeout(id);
    };
  }, []);

  if (!isReady) return null;

  switch (counterKey) {
    case 'wishlist':
      return <WishlistCounter renderCounter={renderCounter} />;
    case 'bonuses':
      return <BonusCounter renderCounter={renderCounter} />;
    case 'cashback':
      return <CashbackCounter renderCounter={renderCounter} />;
    case 'status':
      return <StatusCounter renderCounter={renderCounter} />;
    case 'wheel':
      return <WheelCounter renderCounter={renderCounter} />;
    default:
      return null;
  }
};
